import { render, staticRenderFns } from "./TransactionDetails.vue?vue&type=template&id=2344e475&"
import script from "./TransactionDetails.vue?vue&type=script&lang=js&"
export * from "./TransactionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports